import React from 'react'
import styled from 'react-emotion'
import { SUI } from 'shared/ui'
import Controller from './Controller'

const content = ({ className, hideModal, ...rest }) => {
  return (
    <div className={className}>
      <div className="box">
        <SUI>
          <Controller hideModal={hideModal} {...rest} />
        </SUI>
      </div>
    </div>
  )
}

const Content = styled(content)`
  display: flex;
  height: 430px;

  /**
   * Safari 10 doesn't calculate height of flex children correctly, so we need
   * to set height explicitly for children to use it as basis
   * https://bugs.webkit.org/show_bug.cgi?id=137730
   */
  .safari10 & {
    height: 430px;
  }

  .box {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    overflow: hidden;
    width: 320px;
    z-index: 100;
  }
`

export default Content
